import React, { useEffect, useState } from 'react'
import './ParentChildMedia.css'
import { Breadcrumb, Tooltip, Modal } from "antd"
import ReactPlayer from "react-player";
import { Link, useLocation, useHistory } from "react-router-dom";
import share_icon from '../../UserAssets/images/share.svg'
import Header from '../UserLayout/Header';
import ParentChildTreeResponsive from '../NewParentChild/ParentChildTreeResponsive';
import ParentChildTree from '../NewParentChild/ParentChildTree';
import { fetchAllParentChildCombinedMedia } from '../../Redux/Api/fetch.api';
import Loader from '../loader';
import { Image } from 'react-bootstrap';
import Plus from "../../UserAssets/images/plus.svg";
import SupportRequest from './SupportRequest';
import close_icon from "../../UserAssets/images/closewhite.svg";
import copy_icon from "../../UserAssets/images/copyicon.svg";
import email_icon from "../../UserAssets/images/mailicon.svg";
import Footer from '../UserLayout/Footer';
import noimage from "../../UserAssets/images/noImage.jpg";
import QRCodeGenerator from "../UserLogin/QRCodeGenerator";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { BorderAll } from '@mui/icons-material';

const QRParentChildMedia = () => {
    const [data, setData] = useState({});
    const [isData, setIsdata] = useState(false)
    const { pathname } = useLocation()
    const [loading, setLoading] = useState(false)
    const [isSmallScreen, setisSmallScreen] = useState(window.innerWidth <= 1024)
    const [isPlaying, setIsPlaying] = useState(false);
    // const [currentId, setCurrentid] = useState(pathname.split('/').pop())
    const [backbutton, setBackButton] = useState(false);
    const [checkVirtualCode, setCheckVirtualCode] = useState();
    const [checkVirtualData, setCheckVirtualData] = useState()
    const [checkQRCode, setCheckQRCode] = useState();
    const [virtualCode, setVirtualCode] = useState();
    const [supportModalDisplay, setSupportModalDisplay] = useState(false);
    const baseUrl = window.location.origin;
    const [comingqrId, setComingQrId] = useState(null);
    const [currentId, setCurrentId] = useState(null);
    const [videoModalVisible, setVideoModalVisible] = useState(false);
    const [selectedVideoUrl, setSelectedVideoUrl] = useState("");
    const [selectedVideoTitle, setSelectedVideoTitle] = useState("");

    const [imageModalVisible, setImageModalVisible] = useState(false);
    const [selectedImageUrl, setSelectedImageUrl] = useState("");

    const [selectedImageTitle, setSelectedImageTitle] = useState("");

    const [qrModalVisible, setQrModalVisible] = useState(false);
    const [selectedQrCode, setSelectedQrCode] = useState("");

    const [pdfModalVisible, setPdfModalVisible] = useState(false);
    const [selectedPdfUrl, setSelectedPdfUrl] = useState("");
    const [selectedPdfTitle, setSelectedPdfTitle] = useState("");

    const history = useHistory();

    useEffect(() => {
        const treeContainer = document.querySelector('.tree-responsive');
        if (!treeContainer) return;

        // Make sure all <ul> elements are visible by default
        treeContainer.querySelectorAll('ul').forEach((ul) => {
            ul.style.display = 'block';
        });

        treeContainer.querySelectorAll('li').forEach((li) => {
            const subUl = li.querySelector(':scope > ul');
            if (subUl) {
                li.classList.add('has-children');

                const toggleIcon = document.createElement('i');
                toggleIcon.textContent = '-'; // expanded by default
                toggleIcon.className = 'js-toggle-icon';
                li.insertBefore(toggleIcon, li.firstChild);

                toggleIcon.addEventListener('click', () => {
                    const isExpanded = toggleIcon.textContent === '+';
                    toggleIcon.textContent = isExpanded ? '-' : '+';
                    subUl.style.display = isExpanded ? 'block' : 'none';
                });
            }
        });
    }, [data, isSmallScreen]);


    useEffect(() => {
        const handleResize = () => {
            setisSmallScreen(window.innerWidth <= 1024);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        getparentchilddata(0);
    }, []);

    const getparentchilddata = (qrcode) => {
        setComingQrId(qrcode)
        setLoading(true)
        let comingid = 0;
        if (qrcode) {
            comingid = qrcode;
        }
        else {
            let urlData = location.pathname.split("/");
            if (urlData[1].length < 9) {
                // setCurrentVirtualId(urlData[1])
                setCurrentId(urlData[1]);
                comingid = parseInt(urlData[1])
            }
        }
        if (comingid) {
            getQRDetailsonLoad(comingid);
        }
    }
    const getQRDetailsonLoad = (comingid) => {

        fetchAllParentChildCombinedMedia(comingid)
            .then((response) => {
                if (response.data.success) {
                    setLoading(false)
                    setCheckVirtualCode(response.data.data.isVirtualCode)
                    setCheckQRCode(response.data.data.checkQRCode)
                    setLoading(false)
                    const childQRDetails = response.data.data.childQrDetails;
                    const scanedQRDetails = response.data.data.scanedQRDetails;
                    if (Object.keys(scanedQRDetails).length > 0) {
                        setIsdata(true)
                    } else {
                        setIsdata(false)
                    }

                    if (scanedQRDetails) {
                        setData({
                            ...scanedQRDetails,
                            children: childQRDetails,
                            // children: [],    
                            isExpanded: true
                        });
                    }
                }
                else {
                    setErrorMessage("Qr Code is not valid, please try again.");
                    history.push("/NotFound")
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const updateNodeByPath = (id, parentNode, newChildren, path) => {
        setData(prevData => {
            const clone = structuredClone(prevData);

            let current = clone;
            let parent = null;
            let parentChildren = null;

            for (let i = 0; i < path.length; i++) {
                parent = current;
                parentChildren = parent.children;
                current = parentChildren[path[i]];
            }

            current.isExpand = parentNode.isExpand;
            current.product_Name = parentNode.product_Name;
            current.children = newChildren ? newChildren : [];

            return clone;
        });
    };

    const next = (qrCode) => {
        setBackButton(true)
        qrCode ? history.push({
            pathname: "/" + qrCode, state: {
                parentQrCodeId: currentId
            }
        }) : "";
    };

    const handleCloseButton = (e) => {
        e.preventDefault();
        e.stopPropagation();
        document.querySelector('.dropdown-menu.share-link').classList.remove('show');
    };
    const copyToClipboard = () => {
        const baseUrl = window.location.origin;
        const link = `${baseUrl}/${currentId}`;
        // const link = `https://tekahelp.com/${currentId}`;
        navigator.clipboard.writeText(link)
            .then(() => {
                alert('Link copied to clipboard!');
            })
            .catch(err => {
                console.error('Failed to copy: ', err);
            });
    };
    const handlePlayVideo = (url, title) => {
        setSelectedVideoUrl(url);
        setSelectedVideoTitle(title);
        setVideoModalVisible(true);
    };

    const handleCloseVideo = () => {
        setVideoModalVisible(false);
        setSelectedVideoUrl("");
        setSelectedVideoTitle("");
    };

    const handleOpenImage = (url, title) => {
        setSelectedImageUrl(url);
        setSelectedImageTitle(title);
        setImageModalVisible(true);
    };

    const handleCloseImage = () => {
        setImageModalVisible(false);
        setSelectedImageUrl("");
        setSelectedImageTitle("");
    };

    const handleOpenQR = (qrCode) => {
        setSelectedQrCode(qrCode);
        setQrModalVisible(true);
    };

    const handleCloseQR = () => {
        setQrModalVisible(false);
        setSelectedQrCode("");
    };

    const handleOpenPdf = (url, title) => {
        setSelectedPdfUrl(url);
        setSelectedPdfTitle(title);
        setPdfModalVisible(true);
    };

    const handleClosePdf = () => {
        setPdfModalVisible(false);
        setSelectedPdfUrl("");
        setSelectedPdfTitle("");
    };


    const combinedMedia = Array.isArray(data && data.combinedMedia)
        ? data.combinedMedia
        : [];
    const imageExt = [".jpg", ".jpeg", ".png", ".gif", ".webp", ".bmp", ".svg"];
    const videoExt = [".mp4", ".webm", ".ogg", ".mov", ".m4v"];
    const audioExt = [".mp3", ".wav", ".aac", ".m4a"];

    const resolveMediaItem = (item) => {

        if (typeof item === "string") return { fileName: item, description: "" };
        if (item && typeof item === "object") {
            return {
                fileName: item.fileName || item.filename || item.fileurl || "",
                description: item.description || "",
                videoCoverSrc: item.videoCoverSrc || ""
            };
        }
        return { fileName: "", description: "", videoCoverSrc: "" };
    };

    const getMediaType = (url = "") => {
        if (!url || typeof url !== "string") return "unknown";
        const clean = url.split("?")[0].toLowerCase();
        const ext = clean.slice(clean.lastIndexOf("."));
        if (videoExt.includes(ext)) return "video";
        if (audioExt.includes(ext)) return "audio";
        if (imageExt.includes(ext)) return "image";
        return "unknown";
    };

    //Youtube video
    const isYouTubeUrl = (url = "") => {
        return url.includes("youtube.com") || url.includes("youtu.be");
    };

    const getYouTubeEmbedUrl = (url) => {
        try {
            const urlObj = new URL(url);
            if (url.includes("youtube.com")) {
                return `https://www.youtube.com/embed/${urlObj.searchParams.get("v")}`;
            }
            if (url.includes("youtu.be")) {
                return `https://www.youtube.com/embed/${urlObj.pathname.slice(1)}`;
            }
        } catch {
            return "";
        }
    };


    const mediaItems = combinedMedia
        .map((item) => {
            const normalized = resolveMediaItem(item);
            return { ...normalized, mediaType: getMediaType(normalized.fileName) };
        })
        .filter((item) => {
            if (!item.fileName) return false;
            const cleanUrl = item.fileName.split("?")[0].toLowerCase();
            const lastDot = cleanUrl.lastIndexOf(".");
            const ext = lastDot !== -1 ? cleanUrl.slice(lastDot) : "";
            const docExtensions = [".doc", ".docx", ".xls", ".xlsx", ".txt", ".csv"];
            return !docExtensions.includes(ext);
        });

    const handleRedirect = () => {
        history.push(`/Parent/${currentId}`); // pass your dynamic id
    };

    const handleViewMedia = (mediaItem, title) => {
        if (mediaItem.mediaType === "video" && mediaItem.fileName) {
            handlePlayVideo(mediaItem.fileName, title);
        } else if (mediaItem.mediaType === "audio" && mediaItem.fileName) {
            // Audio has controls, no modal needed
        } else if (isYouTubeUrl(mediaItem.fileName)) {
            handlePlayVideo(mediaItem.fileName, title);
        } else if (mediaItem.fileName && mediaItem.fileName.toLowerCase().split('?')[0].endsWith('.pdf')) {
            handleOpenPdf(mediaItem.fileName, title);
        } else {
            handleOpenImage(mediaItem.fileName || noimage, title);
        }
    };

    const renderMediaPreview = (mediaItem, title) => {

        if (mediaItem.mediaType === "video" && mediaItem.fileName) {
            return (
                <div
                    className="position-relative img-hover"
                    onClick={() => handlePlayVideo(mediaItem.fileName, title)}
                    style={{ cursor: "pointer" }}
                >

                    {mediaItem.videoCoverSrc ? (
                        <img
                            src={mediaItem.videoCoverSrc}
                            alt="video thumbnail"
                            className="w-100 rounded-lg "
                            style={{ height: '200px', objectFit: 'contain', backgroundColor: '#1c1c1c' }}
                        />
                    ) : (

                        <video
                            src={mediaItem.fileName}
                            className="w-100 rounded-lg"
                            style={{ height: '200px', objectFit: 'contain', backgroundColor: '#1c1c1c' }}
                        />
                    )}

                    <div className="play-icon-center">
                        <PlayArrowIcon className="play-icon" />
                    </div>

                    <div className="video-icon-indicator">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-video"
                        >
                            <path d="m22 8-6 4 6 4V8Z"></path>
                            <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
                        </svg>
                    </div>


                </div>
            );

        }

        if (mediaItem.mediaType === "audio" && mediaItem.fileName) {
            return (
                <audio controls className="w-100">
                    <source src={mediaItem.fileName} type="audio/mpeg" />
                </audio>


            );
        }
        if (isYouTubeUrl(mediaItem.fileName)) {
            return (
                <div
                    className="position-relative img-hover"
                    onClick={mediaItem.videoCoverSrc ? () => handlePlayVideo(mediaItem.fileName, title) : undefined}
                    style={{ cursor: mediaItem.videoCoverSrc ? "pointer" : "default" }}
                >
                    {mediaItem.videoCoverSrc ? (
                        <>
                            <img
                                src={mediaItem.videoCoverSrc}
                                alt="video thumbnail"
                                className="w-100 rounded-lg"
                                style={{ height: "200px", objectFit: "contain", backgroundColor: "#1c1c1c" }}
                            />
                            <div className="play-icon-center">
                                <PlayArrowIcon className="play-icon" />
                            </div>
                            <div className="video-icon-indicator">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="white"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-video"
                                >
                                    <path d="m22 8-6 4 6 4V8Z"></path>
                                    <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
                                </svg>
                            </div>
                        </>
                    ) : (
                        <iframe
                            src={getYouTubeEmbedUrl(mediaItem.fileName)}
                            title="YouTube video"
                            className="w-100 rounded-lg"
                            style={{ height: "200px" }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    )}
                </div>
            );
        }
        if (mediaItem.fileName && mediaItem.fileName.toLowerCase().split('?')[0].endsWith('.pdf')) {
            const urlParts = mediaItem.fileName.split('/');
            const displayFileName = urlParts[urlParts.length - 1].split('?')[0] || "Document.pdf";

            return (
                <div
                    className="d-flex align-items-center justify-content-center w-100"
                    style={{ height: '200px', cursor: 'pointer' }}
                    onClick={() => handleOpenPdf(mediaItem.fileName, title)}
                >
                    <div className="d-flex align-items-center p-3 border rounded w-100" style={{ backgroundColor: '#fcfcfc' }}>
                        <div
                            className="d-flex align-items-center justify-content-center text-white rounded me-3"
                            style={{ backgroundColor: '#dc3545', width: '48px', height: '48px', minWidth: '48px', fontWeight: 'bold', fontSize: '14px' }}
                        >
                            PDF
                        </div>
                        <div className="text-truncate" style={{ flex: 1 }}>
                            <div className="text-dark text-truncate" style={{ fontSize: '15px', fontWeight: '500' }}>
                                {displayFileName}
                            </div>
                            <div className="text-muted" style={{ fontSize: '13px', marginTop: '2px' }}>
                                Click to view document
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div
                className="position-relative img-hover"
                style={{ cursor: 'pointer' }}
                onClick={() => handleOpenImage(mediaItem.fileName || noimage, title)}
            >
                <Image
                    src={mediaItem.fileName || noimage}
                    className="w-100 rounded"
                    style={{ height: '200px', objectFit: 'contain', backgroundColor: '#1c1c1c' }}
                    alt={title}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = noimage;
                    }}
                />
                <div className="overlay rounded">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-search"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>
                </div>
            </div>
        );
    };

    return (
        <React.Fragment>
            <section className="new-parent-child">
                {loading && <Loader />}

                <div className="container pb-4 px-0">
                    <div className="mx-auto" style={{ maxWidth: '900px' }}>

                        <div className="d-flex justify-content-between align-items-center position-relative mb-3">

                            <div className="card tile-card position-relative  border-0">

                                <div className="position-absolute top-0 end-0">

                                </div>

                                <div className="d-flex align-items-center gap-lg-3 gap-2 p-lg-3 p-2">

                                    <div
                                        className="position-relative img-hover"
                                        style={{ width: '60px', height: '60px', cursor: 'pointer' }}
                                        onClick={() => handleOpenImage(data && data.thumbnailName || noimage, data && data.product_Name || "Image")}
                                    >

                                        <Image
                                            src={data && data.thumbnailName || noimage}
                                            className="w-100 h-100 rounded object-fit-cover"
                                            alt={data && data.product_Name || "No Image"}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = noimage;
                                            }}
                                        />

                                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center search-icon rounded" style={{ background: 'rgba(0, 0, 0, 0.3)' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-search"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>
                                        </div>
                                    </div>

                                    <div className="flex-grow-1">
                                        <h5 className="fw-bold text-white mb-0">
                                            {data && data.qrCode ? `QR-${data.qrCode}` : ""}
                                        </h5>
                                        <small className="text-white">
                                            {data && data.product_Name || "TEKaLabel"}
                                        </small>
                                    </div>

                                    {data && data.qrCode && (
                                        <div
                                            className="position-relative img-hover"
                                            style={{ width: '60px', height: '60px', cursor: 'pointer' }}
                                            onClick={() => handleOpenQR(data.qrCode)}
                                        >
                                            <QRCodeGenerator qrcodeid={data.qrCode} size={60} />
                                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center search-icon rounded" style={{ background: 'rgba(0, 0, 0, 0.3)' }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-search"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>
                                            </div>
                                        </div>
                                    )}


                                </div>
                            </div>

                        </div>


                        <div className="d-flex align-items-center mb-3 justify-content-between gap-2  topText">
                            <div className='d-flex gap-2 align-items-center'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#d77512" stroke="#5c3810" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-triangle-alert h-4 w-4 text-primary"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path><path d="M12 9v4"></path><path d="M12 17h.01"></path></svg>
                                <h6 className="mb-0 text-white">How can we help you today?</h6>
                            </div>


                            <div className="dropdown shareDropdown">
                                <Tooltip title="Click to redirect tree view">
                                    <button
                                        className="see-more-btn btn-primary"
                                        type="button"
                                        onClick={handleRedirect}
                                    >
                                        See More

                                    </button>
                                </Tooltip>
                            </div>
                        </div>


                        <div className="row g-3">
                            {mediaItems.length > 0 ? (
                                mediaItems.map((item, index) => (
                                    <div className="col-md-6" key={`${item.fileName}-${index}`}>
                                        <div className="card tile-card h-100 d-flex flex-column">
                                            <div className="p-3 pb-2">
                                                {/* {(() => {
                                                    let labelText = "IMAGE";
                                                    let labelColor = "#06b6d4"; // Cyan
                                                    if (isYouTubeUrl(item.fileName) || item.mediaType === "video") {
                                                        labelText = "VIDEO";
                                                        labelColor = "#d97706"; // Orange
                                                    } else if (item.mediaType === "audio") {
                                                        labelText = "AUDIO";
                                                        labelColor = "#8b5cf6"; // Purple
                                                    } else if (item.fileName && item.fileName.toLowerCase().split('?')[0].endsWith('.pdf')) {
                                                        labelText = "PDF";
                                                        labelColor = "#ef4444"; // Red
                                                    }
                                                    return (
                                                        <div className="mb-2 fw-bold" style={{ fontSize: "11px", letterSpacing: "1px", color: labelColor }}>
                                                            {labelText}
                                                        </div>
                                                    );
                                                })()} */}
                                                {renderMediaPreview(item, item.description || "No Description")}
                                            </div>
                                            <div
                                                className="d-flex align-items-center justify-content-between px-3 pb-3 mt-auto"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleViewMedia(item, item.description || "No Description")}
                                            >
                                                <h6 className="mb-0 text-truncate pe-2" style={{ color: '#f5f5f4' }}>{item.description}</h6>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-right flex-shrink-0"><path d="m9 18 6-6-6-6"></path></svg>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12">
                                    <div className="card tile-card h-100">
                                        <div className="p-3 text-muted">No Launch Media found. Please add</div>
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                </div>


            </section>



            {currentId &&
                <Footer qrcodeId={currentId} />
            }

            <Modal
                title={selectedVideoTitle}
                visible={videoModalVisible}
                onCancel={handleCloseVideo}
                footer={null}
                width={800}
                centered
                destroyOnClose={true}
                bodyStyle={{ padding: 0, backgroundColor: '#000', borderRadius: '8px', overflow: 'hidden' }}
            >
                <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                    <ReactPlayer
                        url={selectedVideoUrl}
                        width="100%"
                        height="100%"
                        style={{ position: 'absolute', top: 0, left: 0 }}
                        controls={true}
                        playing={true}
                    />
                </div>
            </Modal>

            <Modal
                title={selectedImageTitle}
                visible={imageModalVisible}
                onCancel={handleCloseImage}
                footer={null}
                width={800}
                centered
                destroyOnClose={true}
                bodyStyle={{ padding: 0, backgroundColor: '#000', borderRadius: '8px', overflow: 'hidden' }}
            >
                <div style={{ position: 'relative', width: '100%', minHeight: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img
                        src={selectedImageUrl}
                        alt={selectedImageTitle}
                        style={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain' }}
                    />
                </div>
            </Modal>

            <Modal
                title={`QR-${selectedQrCode}`}
                visible={qrModalVisible}
                onCancel={handleCloseQR}
                footer={null}
                width={400}
                centered
                destroyOnClose={true}
                bodyStyle={{ padding: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff', borderRadius: '8px' }}
            >
                <div style={{ padding: '20px', background: 'white', borderRadius: '8px' }}>
                    {selectedQrCode && <QRCodeGenerator qrcodeid={selectedQrCode} size={300} />}
                </div>
            </Modal>

            <Modal
                title={selectedPdfTitle}
                visible={pdfModalVisible}
                onCancel={handleClosePdf}
                footer={null}
                width={1000}
                centered
                destroyOnClose={true}
                bodyStyle={{ padding: 0, height: '80vh', overflow: 'hidden', backgroundColor: '#fff', borderRadius: '8px' }}
            >
                <iframe
                    src={selectedPdfUrl}
                    title={selectedPdfTitle}
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                />
            </Modal>
        </React.Fragment>
    )
}

export default QRParentChildMedia
